<div class="table-container">
  <agr-table-v2 matSort [dataSource]="dataSource" class="requests-overview__table-spaced-cols">
    <ng-container matColumnDef="manureCategory">
      <th class="text--bold text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.manureCategory' | translate }}
      </th>
      <td
        class="text--bold"
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.manureCategory' | translate"
        *matCellDef="let row"
      >
        {{ 'manureCategories.' + row.manureCategory | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="manureType">
      <th class="text--bold text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.manureType' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.manureType' | translate"
        *matCellDef="let row"
      >
        {{ 'manureTypes.' + row.manureType | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="amountInTons">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.amountInTons' | translate }}
      </th>
      <td
        class="text--bold text--left"
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.amountInTons' | translate"
        *matCellDef="let row"
      >
        {{ row.amountInTons }}
      </td>
    </ng-container>

    <ng-container matColumnDef="nKgPerTon">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.nKgPerTon' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.nKgPerTon' | translate"
        *matCellDef="let row"
      >
        {{ row.nKgPerTon | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="maxNitrogen">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.maxNitrogen' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.maxNitrogen' | translate"
        *matCellDef="let row"
      >
        {{ row.maxNitrogen | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="pKgPerTon">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.pKgPerTon' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.pKgPerTon' | translate"
        *matCellDef="let row"
      >
        {{ row.pKgPerTon | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="maxPhosphate">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.maxPhosphate' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.maxPhosphate' | translate"
        *matCellDef="let row"
      >
        {{ row.maxPhosphate | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="kKgPerTon">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.kKgPerTon' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.kKgPerTon' | translate"
        *matCellDef="let row"
      >
        {{ row.kKgPerTon | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="isHomogeneous">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.homogeneous' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.homogeneous' | translate"
        *matCellDef="let row"
      >
        <div>
          @switch (row.isHomogeneous) {
            @case (true) {
              <p>{{ 'homogeneity.homogeneous' | translate }}</p>
            }
            @case (false) {
              <p>{{ 'homogeneity.notHomogenous' | translate }}</p>
            }
            @case (null) {
              <p>{{ 'homogeneity.empty' | translate }}</p>
            }
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="desiredDeliveryPeriod">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.desiredDeliveryPeriod' | translate }}
      </th>
      <td
        class="text--bold"
        mat-cell
        [attr.aria-label]="
          'dashboard.overview-table.table-headers.desiredDeliveryPeriod' | translate
        "
        *matCellDef="let row"
      >
        {{
          row.desiredDeliveryPeriodFrom
            ? ('shorthand-months.' + row.desiredDeliveryPeriodFrom | translate)
            : ('' | translate)
        }}
        {{ row.desiredDeliveryPeriodFrom && row.desiredDeliveryPeriodTo ? '-' : '' }}
        {{
          row.desiredDeliveryPeriodTo
            ? ('shorthand-months.' + row.desiredDeliveryPeriodTo | translate)
            : ('' | translate)
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="paymentType">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.paymentType' | translate }}
      </th>
      <td
        mat-cell
        class="paymentType container"
        [attr.aria-label]="'dashboard.overview-table.table-headers.paymentType' | translate"
        *matCellDef="let row"
      >
        @if (row.paymentType === 'Pay') {
          <div class="you-pay-container text--center">
            {{ 'dashboard.overview-table.paymentType.Pay' | translate }}
          </div>
        } @else {
          <div class="you-receive-container text--center">
            {{ 'dashboard.overview-table.paymentType.Receive' | translate }}
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="pricePerTon">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.pricePerTon' | translate }}
      </th>
      <td
        class="text--bold"
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.pricePerTon' | translate"
        *matCellDef="let row"
      >
        {{ row.pricePerTon | currency: 'EUR' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalPrice">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.price' | translate }}
      </th>
      <td
        class="price-container"
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.price' | translate"
        *matCellDef="let row"
      >
        {{ row.totalPrice | currency: 'EUR' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let row">
        @if (row.status === 'MatchRequested') {
          <div
            class="match-requested-container flex--row flex--nowrap flex--justify-center flex--align-center"
          >
            {{ 'dashboard.overview-table.status.' + row.status | translate }}
            <div
              matTooltip="{{ 'dashboard.overview-table.match-made-tooltip' | translate }}"
              class="flex--row flex--align-center text-color--black text--small"
            >
              <mat-icon class="spacing--margin-half-left">info_outline</mat-icon>
            </div>
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th class="text--left" mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        @if (row.status === 'MatchRequested') {
          <div class="text--center">
            <div class="match-button" (click)="openMatchMakingDialog(row)">
              <mat-icon>check</mat-icon>
            </div>
          </div>
        }
        @if (row.status === 'New') {
          <div class="text--center">
            <div class="delete-button" (click)="deleteRequest(row)">
              <mat-icon>delete_outline</mat-icon>
            </div>
          </div>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let myRowData; columns: displayColumns"></tr>
  </agr-table-v2>
</div>
